import { useCallback, useState, useEffect, PointerEvent, FormEvent, Fragment, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import AutoSuggest from '@components/form/AutoSuggest';
//import Keyword from '@components/form/Keyword';
import LiveKeyword from '@components/form/LiveKeyword';
import { selectAlias, selectL10N } from '@features/ui/UiSlice';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { useOption } from '@hooks/useOption';
import { SEARCH_PARAMS } from '@constants/router';
import { setKeyword } from '../ui/UiSlice';

const Form = () => {
  const l10n = useAppSelector(selectL10N);
  const option = useOption();
  const { useLiveKeyword, useAutoSuggest, serviceAlias } = option || {};
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState(searchParams.get(SEARCH_PARAMS.KEYWORD) || '');
  const [isSubmit, setIsSubmit] = useState(false);

  const alias = useAppSelector(selectAlias);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isSubmit) {
      return;
    }

    if (inputValue && inputValue !== searchParams?.get(SEARCH_PARAMS.KEYWORD)) {
      //searchParams.set(SEARCH_PARAMS.KEYWORD, inputValue);
      //setSearchParams(searchParams);
      dispatch(setKeyword(inputValue));
      setIsSubmit(false);
      return;
    }

    setIsSubmit(false);
  }, [isSubmit, searchParams]);

  const submitCommon = useCallback(
    (value: string) => {
      setInputValue(value);
      !isSubmit && setIsSubmit(true);
    },
    [isSubmit]
  );

  // AutoSuggest의 옵션으로 콜백 전달 시, 콜백 내부의 state는 업데이트 되지 않고, 상태값 변경만 가능하여 isSearchReady값과 inputValue만 변경함
  const autoSuggestCallback = useCallback(
    (clickKeyword: string) => {
      submitCommon(clickKeyword);
    },
    [isSubmit]
  );

  return (
    <div id="wrapSearchHeader" className="wrap-search-header">
      <div className="wrap-section-top">
        <div className="wrap-section-searchform">
          <div className="section-searchform">
            <div id="search-autosuggest">
              {/* <Keyword {...{isSubmit, inputValue, setInputValue, l10nTemplate: l10n?.template!}}/> */}
              {useAutoSuggest ? (
                <AutoSuggest inputValue={inputValue} serviceAlias={serviceAlias} submitCallback={autoSuggestCallback} />
              ) : (
                <Fragment />
              )}
            </div>
          </div>
          {useLiveKeyword ? <LiveKeyword serviceAlias={serviceAlias} itemClickCallback={submitCommon} /> : <Fragment />}
        </div>
      </div>
    </div>
  );
};

export default Form;
